import styled from "styled-components";


export const SubmitMissionProgramWrapper = styled.div`
.formParent{
    padding: 2%;
    margin-top: 4%;
    max-width: 80%;
    border: 1px solid #d5d5d5;
    border-radius: 10px;
    padding-top: 4%;
    min-height: 17rem;
}

.formElement{
    margin: 4% 0%;
}

.saveAndTestButton{
    text-align: center;
}
.saveAndTestButton button{
    border: none;
    background: #213861;
    width: 55%;
    padding: 2%;
    border-radius: 5px;
    color: white;
    cursor: pointer;
}
.buttonsSections{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    padding:0 5%;
    margin-top:10%;
}

.submitButton{
    width: 150px;
    display: flex;
    font-size: 11px;
    justify-content: center;
    align-items: center;
    height: 30px;
    background: #0074ff;
    color: white;
    border-radius: 5px;
    cursor: pointer;
}

.ShowImagesParent{
    width: 70%;
    margin: 0 auto 2%;
}
.showImages{
    border:none;
    background: #0074ff;
    color: white;
    border-radius: 5px;
    padding: 2% 2%;
    width: 100%;
}

`;